





















































import { Component, Vue, Ref } from "vue-property-decorator";
import { QDialog } from "quasar";
import { AuthModule } from "@/store";

@Component
export default class SendSurveyDialog extends Vue {
  @Ref("send-survey-dialog")
  dialog!: QDialog;

  @AuthModule.bindings.State
  sending!: boolean;

  sendCompleted = false;

  async onSubmit() {
    try {
      await AuthModule.store.sendSurveys();
      this.sendCompleted = true;
    } catch (error) {
      console.log(error);
    }
  }

  onCancelButton() {
    this.hide();
  }

  onCancel() {
    this.$emit("cancel");
    this.hide();
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDismissClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
